import { ElementsMetadata, ValidationType } from '../../../types';

export function isArrayType(index: number, elementMetadata: ElementsMetadata<any>): boolean {
  return isType(index, ValidationType.ARRAY, elementMetadata);
}
export function isType(index: number, validationType: ValidationType, elementMetadata: ElementsMetadata<any>): boolean {
  return elementMetadata[index]?.validation?.type === validationType;
}
